/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
import type { THueVariationString } from 'volta/utils/style-utils';
import type { BvTooltipSignature } from './../bv-tooltip/index';

interface BvStatusSignature {
  Args: {
    abbreviated?: boolean;
    class?: string;
    color?: THueVariationString;
    isDone?: boolean;
    isError?: boolean;
    minimized?: boolean;
    progress?: number;
    status: string;
    style: string;
    temporary?: boolean;
    tooltip: BvTooltipSignature['Args']['text'];
  };
  Blocks: {
    default: [];
  };
  Element: HTMLSpanElement;
}

const BvStatusComponent = templateOnlyComponent<BvStatusSignature>();

export default BvStatusComponent;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    BvStatus: typeof BvStatusComponent;
    'bv-status': typeof BvStatusComponent;
  }
}
